import { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { IDV360TicketsLineItemForm } from '@/Interfaces/DV360Tickets/LineItem.interface';
import DV360TicketsLineItemSummaryService from '@/Services/CampaignManagement/DV360TicketsLineItemSummary.service';
import InfoTable from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/Summary/InfoTable';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';

const BasicInfo = memo(() => {
  const { getValues } = useFormContext<IDV360TicketsLineItemForm>();

  const values = getValues();

  const basicInfoRows = DV360TicketsLineItemSummaryService.getBasicInfo(values as unknown as ILineItemForm);

  return basicInfoRows.length ? <InfoTable caption='Essential Settings' rows={basicInfoRows} /> : null;
});

export default BasicInfo;
